module.exports = __webpack_public_path__ + "static/user-roles-9f08205e750083dcaf0213fb72fb343b.png";